export default __webpack_public_path__ + "static/media/dl-qr.9c5028bc.svg";